export const ATC_ROUTE_BY_KEY = {
  FOOD: 'FoodSamplesDetailsPage',
  AGRONOMY: 'AgronomySamplesDetailsPage',
  ENVIRONMENT: 'EnvironmentalSamplesDetailsPage',
  MINING: 'MiningSamplesDetailsPage',
  HEALTH_SECURITY: 'HealthAndSecuritySamplesDetailsPage',
};

export function normalizeAtc(value) {
  return (value || '')
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();
}

export function resolveAtcKey(sample = {}) {
  const rawCode = sample.atc_code || '';
  const rawName = sample.atc_name || '';

  const code = normalizeAtc(rawCode);
  const name = normalizeAtc(rawName);

  if (code === 'agronomy' || code === 'agronomia' || name === 'agronomy' || name === 'agronomia') {
    return 'AGRONOMY';
  }

  if (code === 'food' || code === 'alimentaria' || name === 'food' || name === 'alimentaria') {
    return 'FOOD';
  }

  if (
    code === 'environment' ||
    code === 'medio ambiente' ||
    name === 'environment' ||
    name === 'medio ambiente'
  ) {
    return 'ENVIRONMENT';
  }

  if (code === 'mining' || code === 'mineria' || name === 'mining' || name === 'mineria') {
    return 'MINING';
  }

  if (
    code === 'health and security' ||
    code === 'healthsecurity' ||
    code === 'salud y seguridad' ||
    name === 'health and security' ||
    name === 'healthsecurity' ||
    name === 'salud y seguridad'
  ) {
    return 'HEALTH_SECURITY';
  }

  return null;
}

export function resolveSampleDetailsRoute(sample = {}) {
  const key = resolveAtcKey(sample);
  return key ? ATC_ROUTE_BY_KEY[key] : null;
}
